import { useQuery } from "@tanstack/react-query";
import { queryClient } from "shared/api/queryClient";
import { getArticlesList } from "../api/getArticlesList";
import { ArticleBrandId, ArticleCategory } from "../types";

export const QUERY_KEY = "articles";

type Params = {
  brandId: ArticleBrandId;
  categoryId: ArticleCategory;
};

export const useArticleListQuery = ({ brandId, categoryId }: Params) => {
  return useQuery({
    queryKey: [QUERY_KEY, brandId, categoryId],
    queryFn: async () => {
      const data = await getArticlesList(brandId, categoryId);

      return data;
    },
  });
};

export const invalidateArticleListQuery = (params: Params) => {
  return queryClient.invalidateQueries({
    queryKey: [QUERY_KEY, params.brandId, params.categoryId],
  });
};
